module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#logic",
      toString: function () {
        return this.url;
      }
    }